/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'
import { get } from 'lodash'

/**
 * Import
 * - Store
 */
import { RootState } from '../../../store'

/**
 * Import
 * - Actions
 */
// import { forgotTrigger } from '../../../actions'
import { changeNavState, checkQuoteStep, resetStep, getFullQuote, getPolicySingle } from '../../../actions'
/**
 * Import
 * - Page component
 */
import Quote from '../../../components/pages/Quote/Quote'

const mapStateToProps = (state: RootState) => {
    return {
        quote: state.quote,
        quoteStep: state.quote.checkStep.response.step,
        isCollectors: get(state, 'quote.checkStep.response.isCollectors', true),
        isMuseums: get(state, 'quote.checkStep.response.isMuseums', true),
        isDealersStock: get(state, 'quote.checkStep.response.isDealersStock', true),
        policiesSingle: state.policiesSingle,
    }
}

export default connect(mapStateToProps, {
    changeNavState: changeNavState,
    getPolicySingle: getPolicySingle,
    checkQuoteStep,
    resetStep,
    getFullQuote,
})(Quote)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Quote/Quote.tsx